import React, { useState } from 'react'

const PhoneInput = ({ selectedCountry, countries, handleChange, mpesaRequestData, setMpesaRequestData, setIsValidPhoneNumber }) => {
  const [touched, setTouched] = useState(false)

  const handlePhoneChange = (e) => {
    let { value } = e.target

    // Remove any non-digit characters
    value = value.replace(/\D/g, '')

    // Remove leading zero if present
    if (value.startsWith('0')) {
      value = value.slice(1)
    }

    // Remove country code if user entered it
    const countryCode = selectedCountry.code.slice(1) // Remove the '+' from the country code
    if (value.startsWith(countryCode)) {
      value = value.slice(countryCode.length)
    }

    // Limit to a reasonable phone number length (adjust as needed)
    value = value.slice(0, 9)

    // Format the final value with country code
    const formattedValue = `${countryCode}${value}`

    // Validate phone number length
    const isValid = value.length >= 9
    setIsValidPhoneNumber(isValid)

    setMpesaRequestData(prevState => ({
      ...prevState,
      msisdn: formattedValue
    }))
  }

  const handleBlur = () => {
    setTouched(true)
  }

  const showError = touched && mpesaRequestData.msisdn.slice(selectedCountry.code.length - 1).length < 9

  return (
    <div>
      <label htmlFor="phone-input" className="block mb-2 text-sm font-medium text-gray-900">Phone number:</label>
      <div className="flex gap-4">
        <select
          name="country"
          className="rounded-lg border-0 outline-none shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-[#e9b22c] sm:text-sm sm:leading-6 p-2.5"
          value={selectedCountry.name}
          onChange={handleChange}
          disabled
        >
          {countries.map((country) => (
            <option key={country.name} value={country.name}>
              {country.code}
            </option>
          ))}
        </select>
        <input
          type="tel"
          name='msisdn'
          id="phone-input"
          onChange={handlePhoneChange}
          onBlur={handleBlur}
          value={mpesaRequestData.msisdn.slice(selectedCountry.code.length - 1)} // Display without country code
          className={`flex-grow rounded-lg border-0 outline-none shadow-sm ring-1 ring-inset ${showError ? 'ring-red-500' : 'ring-gray-300'
            } focus:ring-[#e9b22c] sm:text-sm sm:leading-6 p-2.5`}
          placeholder="Phone number"
          required
        />
      </div>
      {showError && (
        <p className="mt-2 text-sm text-red-600">Please input a valid phone number i.e 712345678</p>
      )}
    </div>
  )
}

export default PhoneInput
